import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/styles';
import { useParams } from 'react-router-dom';
import { TransactionResult } from '../../shared/enums/transaction-result';
import Failure from './Failure/index';
import Success from './Success/index';

const useStyles = makeStyles({
  mainBox: {
    backgroundColor: '#FFFFFF',
    minWidth: '30%',
    maxWidth: '100%',
    boxShadow:
      '0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07), 0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07), 0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07)',
  },
});

const Transaction = (props: any) => {
  const classes = useStyles(props);
  const { result } = useParams();

  return (
    <>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='100vh'
      >
        <Box p={6} boxShadow={1} className={classes.mainBox}>
          {result === TransactionResult.SUCCESS && <Success />}
          {result === TransactionResult.FAILED && <Failure />}
        </Box>
      </Box>
    </>
  );
};

export default Transaction;
